import classNames from 'classnames';

import styles from '../../EpicMovers.module.scss';

const EpicMoversLoaderRow = () => (
  <tr>
    <td>
      <div className={styles.wrapperCompany}>

        <div className={styles.loadingLogo} />

        <div className={styles.companyInfo}>
          <div className={classNames(styles.loadingComponent, styles.loadingComponentMargin)} />
          <div className={styles.loadingComponent} style={{ width: 134 }} />

        </div>
      </div>
    </td>
    <td>
      <div className={styles.loadingDiv}>
        <div className={classNames(styles.loadingComponent, styles.loadingComponentMargin)} />
      </div>
      <div className={styles.loadingDiv}>
        <div className={styles.loadingComponent} />
      </div>
    </td>
  </tr>
);

export default EpicMoversLoaderRow;
